import {AfterViewInit, Directive, ElementRef, inject, Input, Renderer2} from '@angular/core';

@Directive({
    selector: '[fieldValidator]',
    exportAs: "fieldValidator",
    standalone: false
})
export class FieldValidatorDirective implements AfterViewInit {
  private elementRef: ElementRef = inject(ElementRef);
  private renderer: Renderer2 = inject(Renderer2);

  @Input() fieldValidator: () => string;

  ngAfterViewInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'validatable');
    this.elementRef.nativeElement.onblur = () => this.checkFieldValidity();
  }

  checkFieldValidity(): void {
    const errorMessage = this.fieldValidator ? this.fieldValidator() : null;
    if (errorMessage) {
      this.showError(errorMessage);
    } else {
      this.clearError();
    }
  }

  private showError(errorMessage: string): void {
    const existingError = this.elementRef.nativeElement.parentElement.querySelector('.invalid-feedback');
    if (!existingError) {
      const errorDiv = this.renderer.createElement('div');
      this.renderer.addClass(errorDiv, 'invalid-feedback');
      this.renderer.addClass(errorDiv, 'text-danger');
      const text = this.renderer.createText(errorMessage);
      this.renderer.appendChild(errorDiv, text);
      this.renderer.appendChild(this.elementRef.nativeElement.parentElement, errorDiv);  // Append error message next to the input
    } else {
      $(existingError).empty();
      const text = this.renderer.createText(errorMessage);
      this.renderer.appendChild(existingError, text);
    }
    this.renderer.addClass(this.elementRef.nativeElement, 'ng-invalid');
    this.renderer.addClass(this.elementRef.nativeElement.parentElement, 'was-validated');
  }

  private clearError(): void {
    const existingError = this.elementRef.nativeElement.parentElement.querySelector('.invalid-feedback');
    if (existingError) {
      this.renderer.removeChild(this.elementRef.nativeElement.parentElement, existingError);
    }
    this.renderer.removeClass(this.elementRef.nativeElement, 'ng-invalid');
    this.renderer.addClass(this.elementRef.nativeElement, 'ng-valid');
  }
}
